'use client';

import { useState } from 'react';
import { ArrowLeft, LayoutDashboard, Users, FileText, ShoppingCart, Receipt } from 'lucide-react';
import { SellingDashboard } from './components/SellingDashboard';
import { CustomerListPage } from './components/CustomerList';
import { QuotationListPage } from './components/QuotationList';
import { SalesOrderListPage } from './components/SalesOrderList';
import { InvoiceListPage } from './components/InvoiceList';

export type SellingPage = 'dashboard' | 'customers' | 'quotations' | 'orders' | 'invoices';

interface SellingModuleProps {
  onBack?: () => void;
}

const menuItems: { id: SellingPage; label: string; icon: typeof LayoutDashboard }[] = [
  { id: 'dashboard', label: '대시보드', icon: LayoutDashboard },
  { id: 'customers', label: '고객 관리', icon: Users },
  { id: 'quotations', label: '견적서', icon: FileText },
  { id: 'orders', label: '판매 주문', icon: ShoppingCart },
  { id: 'invoices', label: '청구서', icon: Receipt },
];

export function SellingModule({ onBack }: SellingModuleProps) {
  const [currentPage, setCurrentPage] = useState<SellingPage>('dashboard');

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <SellingDashboard onNavigate={setCurrentPage} />;
      case 'customers':
        return <CustomerListPage />;
      case 'quotations':
        return <QuotationListPage />;
      case 'orders':
        return <SalesOrderListPage />;
      case 'invoices':
        return <InvoiceListPage />;
      default:
        return <SellingDashboard onNavigate={setCurrentPage} />;
    }
  };

  return (
    <div className="flex flex-col h-full -m-6">
      {/* 상단 네비게이션 */}
      <div className="flex items-center gap-2 px-4 py-3 bg-card border-b border-border">
        {onBack && (
          <button
            onClick={onBack}
            className="p-2 rounded-lg hover:bg-accent"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        )}
        <h1 className="text-xl font-bold mr-6">판매 관리</h1>

        {/* 탭 메뉴 */}
        <div className="flex items-center gap-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPage === item.id;
            return (
              <button
                key={item.id}
                onClick={() => setCurrentPage(item.id)}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:text-foreground hover:bg-accent'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="hidden sm:inline">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* 페이지 컨텐츠 */}
      <div className="flex-1 overflow-auto p-6">
        {renderPage()}
      </div>
    </div>
  );
}
